import { render, staticRenderFns } from "./CallOrderNew.vue?vue&type=template&id=3763960e&scoped=true"
import script from "./CallOrderNew.vue?vue&type=script&lang=js"
export * from "./CallOrderNew.vue?vue&type=script&lang=js"
import style0 from "./CallOrderNew.vue?vue&type=style&index=0&id=3763960e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3763960e",
  null
  
)

export default component.exports